import { createContext, useContext, useState, useCallback } from 'react'

import { VIEW_AS_INVESTOR, getViewAsInvestor, isAdmin } from '../utils/auth-storage'

const ViewAsContext = createContext({ viewAs: null, isAdmin: false, setViewAs: () => {} })

export const ViewAsProvider = ({ children }) => {
	const [viewAs, setViewAsState] = useState(getViewAsInvestor())
	const admin = isAdmin()

	const setViewAs = useCallback(investor => {
		if (investor?.id) {
			localStorage.setItem(VIEW_AS_INVESTOR, JSON.stringify({ id: investor.id, name: investor.name }))
		} else {
			localStorage.removeItem(VIEW_AS_INVESTOR)
		}
		setViewAsState(investor?.id ? investor : null)
		// Reload the cabinet from home so every query refetches with the new
		// View-As-Investor-Id header applied by the axios interceptor.
		window.location.assign('/')
	}, [])

	return <ViewAsContext.Provider value={{ viewAs, isAdmin: admin, setViewAs }}>{children}</ViewAsContext.Provider>
}

export const useViewAs = () => useContext(ViewAsContext)
